import SelectableCardGroup from './common/SelectableCardGroup';

const OPTIONS = [
  {
    key: 'reasonable',
    title: '합리적인 만족형',
    desc: '부담스럽지 않은 선에서 만족하고 싶어요',
    meta: <p className="text-[11px] text-softgold font-medium">70~90만원대</p>,
  },
  {
    key: 'balance',
    title: '밸런스 중시형',
    desc: '가격과 퀄리티 균형이 중요해요',
    meta: <p className="text-[11px] text-softgold font-medium">90~120만원대</p>,
  },
  {
    key: 'premium',
    title: '프리미엄 집중형',
    desc: '예복은 확실히 투자할 가치가 있어요',
    meta: <p className="text-[11px] text-softgold font-medium">130만원 이상</p>,
  },
];

interface StepStyleProps {
  value: string | null;
  onChange: (val: string) => void;
}

export default function StepStyle({ value, onChange }: StepStyleProps) {
  return (
    <SelectableCardGroup
      options={OPTIONS}
      value={value}
      onChange={onChange}
      variant="plain"
    />
  );
}
